import { gql } from '@apollo/client'
import { purchaseOrderFragment } from './graphql'
import { useMutation } from '@ztechapps/common.hook'
import type { PurchaseOrder } from '@ztechapps/common.contract'

const query = gql`
  ${purchaseOrderFragment}
  mutation createPurchaseOrder($input: JSON!) {
    createPurchaseOrder(input: $input) {
      ...purchaseOrderFragment
    }
  }
`
export const useCreatePurchaseOrder = () => {
  return useMutation<{ createPurchaseOrder: PurchaseOrder }, PurchaseOrder>({ query })
}
